import React, {useState, useEffect, Fragment} from 'react'
//import {times} from 'lodash';
import Image from '../Image'
import plate from '../../../assets/img/icon-plate.svg';
import {useTranslation} from 'react-i18next';
import { currentLang } from '../../../utils/functions';
import { setStorage, getStorage, removeStorage, customStorageReturnValue } from '../../../utils/storage';
import { useHistory, useLocation } from 'react-router-dom';
import {isNil} from 'lodash';
import W from '../Word';

const ProductAdd = ({defaultValue, packageInfo, parentCallback, urlChange}) => {
    const [num, setNum] = useState(null);
    const { t } = useTranslation();
    const {pathname} = useLocation();
    var storageKey = pathname+'_'+packageInfo.name;
    var ttl = 4*60*60*1000;
    const [total, setTotal] = useState(packageInfo.total_pieces);
    //console.log(packageInfo);
    const unit_single_plural = t('product.'+packageInfo.unit_single+'_interval', {postProcess: 'interval', count: total})
    const gram_plural = t('product.grameach_interval', {postProcess: 'interval', count: total})

    useEffect(() => {
       setNum(defaultValue);
    }, [defaultValue])

    useEffect(() => {  
        if(!isNil(num)){
          urlChange(packageInfo.name, num);
          setTotal(num * packageInfo.pieces_per_vac);
        }
    }, [num])

    const plus = () =>{
      setNum(num+1);
      parentCallback(1);
    }

    const minus = () =>{
      if(num > 0){
        setNum(num-1);
        parentCallback(0);
      }
      
    }

    return (
      <Fragment>
        {packageInfo &&   
            <Fragment>
                <div className="row border package__quantity">
                    <div className="col-5 col-md-6 col-xl-6">
                      <a className="pr-3" href={"/"+currentLang()+"/"+t("menu.meatcuts")+"/"+packageInfo.frontend_name_detailpage}>
                        {packageInfo.frontend_name}
                      </a>
                    </div>
                    <div className="col-4 col-md-3 col-xl-4">
                        <div className="package__meals">
                        {t('product.product_details_minced_packages', {total_pieces: total, unit: unit_single_plural, weight: packageInfo.weight, gram: gram_plural})}
                        </div>
                    </div>
                    <div className="col-3 col-md-3 col-xl-2">
                      <div className="product-add">
                          <span onClick={minus}> <i className="icon-minus"></i> </span>
                            {/*<input type="number" value={num} onChange={change} />*/}
                            {num}
                          <span onClick={plus}> <i className="icon-plus"></i> </span>
                      </div> 
                    </div>
                </div>
            </Fragment>
        }
      </Fragment>
    )
}

export default ProductAdd
